// this variable should be removed once auto weather is fully mature and no more hacks are inplace
// the order of the auto weather products matters, it will decide the order that the filters show up
// in the product list page
export const AUTO_WEATHER_PRODUCT_TYPES = [5, 8, 12, 10, 14];
// enabled product ids that are supported in the product event architecture
export const ENABLED_PRODUCT_TYPES = [1, 2, 3, 6, 5].concat(AUTO_WEATHER_PRODUCT_TYPES);

// product name constants, this could be more dynamic if you wanted var SKYGUARD = 'SKYGUARD'; // 1
export const SKYGUARD = 'SKYGUARD';
export const PUBLICWARNING = 'PUBLICWARNING';
export const EARTHQUAKE = 'EARTHQUAKE';
export const NULLNOTIFICATION = 'NULLNOTIFICATION';
export const LOCALSTORMREPORT = 'LOCALSTORMREPORT';
export const LIGHTNINGPROXIMITY = 'LIGHTNINGPROXIMITY';
export const STORMPOTENTIALNOTICE = 'STORMPOTENTIALNOTICE';
export const STORMPOTENTIALOUTLOOK = 'STORMPOTENTIALOUTLOOK';
export const GLOBALHAZARD = 'GLOBALHAZARD';
export const TROPICAL = 'TROPICAL';
export const UNSUPPORTED_PRODUCT = 'UNSUPPORTED_PRODUCT';
export const LOADING_PRODUCT = 'LOADING_PRODUCT';
